import { render, staticRenderFns } from "./NoLicense.vue?vue&type=template&id=015331ca&scoped=true&"
import script from "./NoLicense.vue?vue&type=script&lang=js&"
export * from "./NoLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015331ca",
  null
  
)

export default component.exports